import {Typography, useTheme} from "@mui/material";
import {formatCurrency} from "../../utils/formatters";

export const Alerts = ({data, clickHandler, minimal = false}) => {
    const theme = useTheme();
    const dims = theme.dimensions;
    const panelTheme = theme.palette.contentPanel;
    const indicatorTheme = theme.palette.indicator;

    const alerts = [
        {key: 'negativeMarginOrders', description: 'Order(s) with negative margin in selected time period', short: 'Orders to review'},
        {key: 'negativeMarginSKUs', description: 'SKU(s) with negative margin', short: 'SKUs negative margin'},
        {key: 'underPricedSKUs', description: 'SKU(s) under priced', short: 'SKUs under priced'},
        {key: 'inactiveAccounts', description: 'Account(s) with no purchases in last 6 months', short: 'Accounts no purchases'},
        {key: 'noPriceChanges', description: 'Account(s) with no price changes in last 12 months and VM/Unit decreasing', short: 'Accounts no price changes'},
        {key: 'negativeMarginAccounts', description: 'Account(s) with negative margin', short: 'Accounts negative margin'}
    ]

    const determineColor = (value) => {
        //TODO: move these values to app layout or config somewhere...
        const redMin = 400000;
        const orangeMin = 25000;
        return minimal ? (value > redMin ? indicatorTheme.red : value > orangeMin ? indicatorTheme.orange : indicatorTheme.yellow) : indicatorTheme.red;
    };

    const tableRows = [];
    for (const alert of alerts) {
        if (data[alert.key]) {
            const countCalc = data[alert.key].find((c) => c.field.endsWith('count'));
            if (!countCalc) {
                continue;
            }
            const count = countCalc.value;
            const fakeProfitImpact = count * 2000; //TODO: get rid of this...
            const profitImpactCalc = (data[alert.key]).filter(c => c.field === 'profit_impact');
            const profitImpact = Math.abs(profitImpactCalc.length > 0 ? profitImpactCalc[0].value : fakeProfitImpact);
            tableRows.push(
                minimal ?
                    <tr key={alert.key} onClick={() => clickHandler(alert.key)} style={{cursor: "pointer"}}>
                        <td><Typography variant="h6" style={{marginLeft: 5}}> {alert.short}</Typography></td>
                        <td><Typography variant="h6" style={{textAlign: "right"}} color={determineColor(profitImpact)}>{formatCurrency(profitImpact, true)}</Typography></td>
                        <td><Typography variant="h6" style={{textAlign: "right"}} color={determineColor(profitImpact)}>{count}</Typography></td>
                    </tr>
                    :
                    <tr key={alert.key} onClick={() => clickHandler(alert.key)} style={{cursor: "pointer"}}>
                        <td><Typography variant="h5" style={{textAlign: "right"}} color={determineColor()}>{count}</Typography></td>
                        <td><Typography variant="h5" style={{marginLeft: 5}}> {alert.description}</Typography></td>
                    </tr>
            )
        }
    }

    return (
        <div style={{...panelTheme, marginTop: 10, padding: 10, width: minimal ? dims.smallPanelWidth : dims.contentWidth}}>
            {!minimal &&
                <Typography variant="h4" style={{marginBottom: 5}}>Alerts</Typography>
            }
            <table style={{width: minimal ? dims.smallPanelWidth - 40 : dims.contentWidth}}>
                {minimal &&
                    <thead>
                    <tr>
                        <th style={{textAlign: "left"}}><Typography variant="h5" style={{marginBottom: 25}}>Alerts</Typography></th>
                        <th style={{textAlign: "center"}}>Profit<br/>Impact</th>
                        <th style={{textAlign: "right"}}><br/>Count</th>
                    </tr>
                    </thead>
                }
                <tbody>
                {tableRows}
                </tbody>
            </table>
            {minimal && <div style={{marginBottom: 20}}/>}
        </div>
    );
};